export const extendUrlIPCC = {
    url: import.meta.env.REACT_URL_IPCC || "http://localhost:9900"
}

export const extentUrlLogin = {
    url: import.meta.env.REACT_URL_LOGIN || "https://admin.callstack.vn:2008/passportv3/login"
}
